/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Credential,
  PaginatedSearchHistoryList,
  SearchHistory,
} from '../models/index';
import {
    CredentialFromJSON,
    CredentialToJSON,
    PaginatedSearchHistoryListFromJSON,
    PaginatedSearchHistoryListToJSON,
    SearchHistoryFromJSON,
    SearchHistoryToJSON,
} from '../models/index';

export interface CredentialRetrieveRequest {
    id: number;
    teamSlug: string;
}

export interface CredentialSearchRequest {
    query: string;
    teamSlug: string;
}

export interface LeaksSearchHistoryListRequest {
    teamSlug: string;
    page?: number;
    pageSize?: number;
}

export interface LeaksSearchHistoryRetrieveRequest {
    id: string;
    teamSlug: string;
}

/**
 * 
 */
export class LeaksApi extends runtime.BaseAPI {

    /**
     * API endpoint for searching credentials in the leaks database.
     */
    async credentialRetrieveRaw(requestParameters: CredentialRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Credential>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling credentialRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/leaks/{team_slug}/credentials/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CredentialFromJSON(jsonValue));
    }

    /**
     * API endpoint for searching credentials in the leaks database.
     */
    async credentialRetrieve(requestParameters: CredentialRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Credential> {
        const response = await this.credentialRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for searching credentials in the leaks database.
     */
    async credentialSearchRaw(requestParameters: CredentialSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Credential>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling credentialSearch().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling credentialSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/leaks/{team_slug}/credentials/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CredentialFromJSON));
    }

    /**
     * API endpoint for searching credentials in the leaks database.
     */
    async credentialSearch(requestParameters: CredentialSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Credential>> {
        const response = await this.credentialSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing search history.
     */
    async leaksSearchHistoryListRaw(requestParameters: LeaksSearchHistoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSearchHistoryList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling leaksSearchHistoryList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/leaks/{team_slug}/search-history/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSearchHistoryListFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing search history.
     */
    async leaksSearchHistoryList(requestParameters: LeaksSearchHistoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSearchHistoryList> {
        const response = await this.leaksSearchHistoryListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint for managing search history.
     */
    async leaksSearchHistoryRetrieveRaw(requestParameters: LeaksSearchHistoryRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchHistory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling leaksSearchHistoryRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling leaksSearchHistoryRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/leaks/{team_slug}/search-history/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchHistoryFromJSON(jsonValue));
    }

    /**
     * API endpoint for managing search history.
     */
    async leaksSearchHistoryRetrieve(requestParameters: LeaksSearchHistoryRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchHistory> {
        const response = await this.leaksSearchHistoryRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
